export default __webpack_public_path__ + "static/media/EventFrameNull.cedd9754.png";